import { lazy } from 'react'

export const AssignmentRoutes = [
    {
        path: '/assignment/list',
        component: lazy(() => import('../views/assignment-list')),
        meta: {
            action: "call",
            resource: "AST_MANAGE_ASSIGNMENT"
        }
    },
    {
        path: '/assignment/add',
        component: lazy(() => import('../views/assignment-crud')),
        meta: {
            action: "call",
            resource: "AST_MANAGE_ASSIGNMENT"
        }
    },
    {
        path: '/assignment/:id/edit',
        component: lazy(() => import('../views/assignment-crud')),
        meta: {
            action: "call",
            resource: "AST_MANAGE_ASSIGNMENT"
        }
    }
]

